export const validateYear = (date) => {
  const year = new Date(date).getFullYear();
  if (isNaN(year) || year.toString().length !== 4) {
    return false;
  }

  return true;
};
